import { render } from "./MainNavigation.vue?vue&type=template&id=a3c1d29a&scoped=true"
import script from "./MainNavigation.vue?vue&type=script&lang=js"
export * from "./MainNavigation.vue?vue&type=script&lang=js"

import "./MainNavigation.vue?vue&type=style&index=0&id=a3c1d29a&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/chaizen_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3c1d29a"]])

export default __exports__